import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { /* Button, */ Form, Button as bsButton, FormGroup, Label, Input, FormText, Col, Row, InputGroup, InputGroupAddon, InputGroupButtonDropdown } from "reactstrap";
import Card from "@material-ui/core/Card";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import ChatIcon from "@material-ui/icons/Chat";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import AddBoxIcon from "@material-ui/icons/AddBox";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import ReactDragList from "react-drag-list";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";

import "./QuestionStyle.css";
import { deepClone } from "../../../../../helpers/objectHelper";
import { questionActions } from "../../../../../store/actions/question/question.action";
import ConfirmModal from "../../../../../components/ConfirmModal/ConfirmModal";
import Select from "react-select";
import { labelHelper } from "../../../../../helpers/labelHelper";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const textPresenterTypes = [
  { value: "NONE", label: <SystemLabel name="None" /> },
  { value: "WORDCLOUD", label: <SystemLabel name="WordCloud" /> },
  { value: "TEXTFLOW", label: <SystemLabel name="TextFlow" /> },
];
const optionPresenterTypes = [
  { value: "NONE", label: <SystemLabel key={"None"} name="None" /> },
  { value: "BARCHART", label: <SystemLabel key={"Barchart"} name="BarChart" /> },
  { value: "COLUMNCHART", label: <SystemLabel key={"ColumnChart"} name="ColumnChart" /> },
  { value: "PIECHART", label: <SystemLabel key="PieChart" name="PieChart" /> },
  { value: "DISPARITYCHART", label: <SystemLabel key="DisparityChart" name="DisparityChart" /> },
  // { value: "LINECHART", label: <SystemLabel name="LineChart" /> },
];

const customStyles = {
  control: (provided, state) => ({
    ...provided,

    backgroundColor: "rgb(58, 59, 60)",
    color: "#ffffffde",
    border: "0px",
    width: "100%",
    maxWidth: "100%",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: "green",
    maxWidth: "100%",
  }),
  input: (provided, state) => ({
    ...provided,
    color: "#ffffffde",
    maxWidth: "100%",
    border: 0,
    ["&:focus"]: {
      outline: 0,
      border: 0,
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#ffffffde",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#1d1d1d",
    maxWidth: "100%",
    zIndex: 100,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#20a8d8" : "rgb(47, 47, 47)",
    color: "#ffffffde",
    ["&:hover"]: {
      backgroundColor: "#5a5959ba",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#eee",
  }),
};

function EditQuestion(props) {
  const [question, setQuestion] = React.useState(null);
  const [placeholderOption, newOption] = React.useState("");
  const [modalOpen, toggleModal] = React.useState(false);
  const currentPresenterTypes = useMemo(() => {
    if (question && question.type == "Text") return textPresenterTypes;
    else if (question && question.type == "Option") return optionPresenterTypes;
    else return [];
  }, [question]);

  useEffect(() => {
    if (!question || props.selectedQuestion.questionId !== question.questionId) {
      setQuestion(deepClone(props.selectedQuestion));
    }
    if (props.saveRequest) {
      saveQuestion();
      props.snackbarHandler("QuestionUpdated");
      props.closeSaveRequest(true);
    } else if (props.deleteRequest) {
      deleteQuestion();
      props.snackbarHandler("QuestionDeleted");
      props.closeDeleteRequest(true);

      props.toggleQuestionInfo(null);
    }
    return () => null;
  });

  /*   useEffect(() => {
    if(props.selectedQuestion.questionId != question.questionId) setQuestion(props.selectedQuestion)
  }, [props.selectedQuestion]) */

  const { open, language, user, onQuestionAdd } = props;
  const handleClose = () => {
    toggleModal(false);
  };
  const sortOptions = (options) => {
    if (options.length === 0) return [];
    options.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    return options;
  };

  const saveQuestion = () => {
    const { dispatch } = props;
    const cQuestion = deepClone(question);
    dispatch(questionActions.updateQuestion(cQuestion));
  };
  const deleteQuestion = () => {
    const { dispatch } = props;
    dispatch(questionActions.deleteQuestion(question.questionId));
  };
  const addOption = () => {
    const name = placeholderOption;
    const sortOrder = question.questionOption.length > 0 ? question.questionOption.length + 1 : 1;

    const questionOptionIds = question?.questionOption?.filter((qo) => qo.questionOptionId < 0)?.map((qo) => qo.questionOptionId);
    const newQuestionOptionId = questionOptionIds?.length ? Math.min(...questionOptionIds) - 1 : -1;

    const option = {
      questionId: question.questionId,
      questionOptionLanguage: [
        {
          label: name,
          languageCode: props.lang,
        },
      ],
      questionOptionId: newQuestionOptionId,
      sortOrder,
    };
    newOption("");

    const uOptions = Array.from(question.questionOption);
    uOptions.push(option);
    handleChange(uOptions, "questionOption");
  };

  const onOptionLabelChange = (id, value) => {
    const uQuestion = Object.assign({}, question);
    const options = Array.from(uQuestion.questionOption);
    const optionsLangs = options?.flatMap((ql) => ql.questionOptionLanguage.map((qol) => qol.languageCode));

    if (!optionsLangs.includes(props.lang)) {
      const copiedOption = options[0];
      copiedOption.languageCode = props.lang;
      copiedOption.label = value;
      options.push(copiedOption);
    } else {
      options.map((ql) => {
        if (ql.questionOptionId === id) {
          ql.questionOptionLanguage.map((qol) => {
            if (qol.languageCode === props.lang) {
              qol.label = value;
            }
          });
        }
      });
    }

    uQuestion.questionOption = options;
    setQuestion(uQuestion);
    props.setSavable(true);
  };

  const onLabelChange = (value, isOption = false) => {
    const uQuestion = deepClone(question);
    const labels = Array.from(uQuestion.questionLanguage);

    const labelLangs = labels.map((ql) => ql.languageCode);

    if (!labelLangs.includes(props.lang)) {
      const copiedLabel = labels[0];
      copiedLabel.languageCode = props.lang;
      copiedLabel.label = value;
      labels.push(copiedLabel);
    } else {
      labels.map((ql) => {
        if (ql.languageCode === props.lang) {
          ql.label = value;
        }
      });
    }

    uQuestion.questionLanguage = labels;
    setQuestion(uQuestion);
    props.setSavable(true);
  };

  const handleOrderChange = (event, dataSource) => {
    const sortedOptions = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i;
      return el;
    });
    handleChange(sortedOptions, "questionOption");
  };

  const handleChange = (value, path) => {
    const uQuestion = Object.assign({}, question);
    uQuestion[path] = value;
    setQuestion(uQuestion);
    props.setSavable(true);
  };
  const deleteOption = (index) => {
    const uOptions = Array.from(question.questionOption);
    uOptions.splice(index, 1);
    handleChange(uOptions, "questionOption");
    toggleModal(false);
  };

  const { personTypes } = props;

  const personTypeOptions = [];
  personTypeOptions.push({
    value: null,
    label: labelHelper.getLabel("PersonTypeNone"),
  });

  if (personTypes) {
    personTypes.map((t) => {
      personTypeOptions.push({ value: t.personTypeId, label: t.name });
    });
  }

  if (!question) return null;
  return (
    <div
      className="dark-list"
      style={{
        maxHeight: "calc(100vh - 222px)",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: 5,
        margin: 10,
      }}
    >
      <Row>
        <Col>
          <FormGroup>
            <Label className="secondary-text" for="questionName">
              <SystemLabel name="QuestionName" />
            </Label>
            <Input
              style={{
                backgroundColor: "#3a3b3c",
                marginBottom: "0px",
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                borderRadius: "5px",
                padding: "5px 10px",
                border: "0px",
              }}
              type="text"
              name="name"
              value={question.questionLanguage.find((ql) => ql.languageCode === props.lang) ? question.questionLanguage.find((ql) => ql.languageCode === props.lang).label : ""}
              onChange={(e) => onLabelChange(e.target.value)}
              id="questionName"
            />
          </FormGroup>
        </Col>
      </Row>

      {question.type === "Text" ? (
        <Row>
          <Col>
            <FormGroup style={{ width: "30%" }}>
              <Label className="secondary-text" for="exampleEmail">
                <SystemLabel name="AllowedAnswerCount" />
              </Label>
              <Input
                style={{
                  backgroundColor: "#3a3b3c",
                  marginBottom: "0px",
                  color: "rgba(255, 255, 255, 0.6)",
                  fontSize: "0.875rem",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  border: "0px",
                }}
                onChange={(e) => handleChange(e.target.value, "allowedAnswerCount")}
                type="number"
                value={question.allowedAnswerCount || ""}
              />
            </FormGroup>
          </Col>
        </Row>
      ) : null}
      {question.type === "Option" ? (
        <FormGroup>
          <Row form>
            <Col /* md={6} */>
              <FormGroup>
                <Label className="secondary-text" for="exampleEmail">
                  <SystemLabel name="AllowedAnswerCount" />
                </Label>
                <Input
                  style={{
                    backgroundColor: "#3a3b3c",
                    marginBottom: "0px",
                    color: "rgba(255, 255, 255, 0.6)",
                    fontSize: "0.875rem",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    border: "0px",
                  }}
                  onChange={(e) => handleChange(e.target.value, "allowedAnswerCount")}
                  type="number"
                  value={question.allowedAnswerCount || ""}
                />
              </FormGroup>
            </Col>
            <Col /* md={6} */>
              <FormGroup>
                <Label className="secondary-text" for="exampleEmail">
                  <SystemLabel name="RequiredMin" />
                </Label>
                <Input
                  style={{
                    backgroundColor: "#3a3b3c",
                    marginBottom: "0px",
                    color: "rgba(255, 255, 255, 0.6)",
                    fontSize: "0.875rem",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    border: "0px",
                  }}
                  onChange={(e) => handleChange(e.target.value, "requiredMin")}
                  type="number"
                  value={question.requiredMin || ""}
                />
              </FormGroup>
            </Col>
            <Col /* md={6} */>
              <FormGroup>
                <Label className="secondary-text" for="exampleEmail">
                  <SystemLabel name="RequiredMax" />
                </Label>
                <Input
                  style={{
                    backgroundColor: "#3a3b3c",
                    marginBottom: "0px",
                    color: "rgba(255, 255, 255, 0.6)",
                    fontSize: "0.875rem",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    border: "0px",
                  }}
                  onChange={(e) => handleChange(e.target.value, "requiredMax")}
                  type="number"
                  value={question.requiredMax || ""}
                />
              </FormGroup>
            </Col>
          </Row>
        </FormGroup>
      ) : null}
      <Row>
        <Col>
          <FormGroup className="w-100">
            <Label className="secondary-text">
              <SystemLabel name="WhoIsNotAllowed" />
            </Label>
            <Select styles={customStyles} options={personTypeOptions} value={personTypeOptions.find((el) => el.value == question.personType)} onChange={(opt) => handleChange(opt.value, "personType")}></Select>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="w-100">
            <Label className="secondary-text">
              <SystemLabel name="PresenterType" />
            </Label>
            <Select
              key={question.questionid}
              id={"question-" + question.questionId}
              styles={customStyles}
              options={currentPresenterTypes}
              value={currentPresenterTypes.find((el) => el.value == (question.presenterType || "NONE"))}
              onChange={(opt) => handleChange(opt.value, "presenterType")}
            ></Select>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup className="w-100">
            <Label className="secondary-text" for="exampleEmail">
              <SystemLabel name="Tags" />
            </Label>
            <Input
              type="textarea"
              style={{
                backgroundColor: "#3a3b3c",
                marginBottom: "0px",
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                borderRadius: "5px",
                padding: "5px 10px",
                border: "0px",
              }}
              onChange={(e) => handleChange(e.target.value, "tag")}
              value={question.tag || ""}
            />
          </FormGroup>
          <p className="secondary-text" style={{ lineHeight: "initial" }}>
            <em>
              {" "}
              <SystemLabel name="TagInfo" />
            </em>
          </p>
        </Col>
      </Row>

      {question.type === "Option" ? (
        <FormGroup>
          <Label className="secondary-text" for="exampleAddress2">
            <SystemLabel name="Options" />
          </Label>
          <InputGroup>
            <Input
              style={{
                backgroundColor: "#3a3b3c",
                marginBottom: "0px",
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                borderRadius: "5px",
                padding: "5px 10px",
                border: "0px",
              }}
              value={placeholderOption || ""}
              onChange={(e) => newOption(e.target.value)}
            />
            <InputGroupAddon addonType="append">
              <Button disabled={!placeholderOption} className="icon-button-dark-s" onClick={addOption}>
                <AddIcon />
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>
      ) : null}
      {question.type === "Option" ? (
        <List dense={true}>
          <ReactDragList
            animation={10}
            dataSource={sortOptions(question.questionOption)}
            rowKey={"questionOptionId"}
            className="simple-drag"
            rowClassName="simple-drag-row"
            handles={false}
            onUpdate={(event, dataSource) => handleOrderChange(event, dataSource)}
            row={(o, index) => {
              return (
                <Card
                  style={{
                    margin: "5px 0px",
                    width: "100%",
                    boxShadow: "none",
                    display: undefined,
                  }}
                  className="dark-card"
                >
                  <ListItem>
                    <Col className="col-2 text-left " style={{ margin: 0, /* marginRight: 15, */ padding: 0 }}>
                      <IconButton className="icon-button-dark-s" style={{ cursor: "move" }}>
                        <DragIndicatorIcon />
                      </IconButton>
                    </Col>
                    <Col className="col-8 " style={{ margin: 0, padding: 0 }}>
                      <Input
                        style={{
                          backgroundColor: "#3a3b3c",
                          marginBottom: "0px",
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: "0.875rem",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          border: "0px",
                        }}
                        onChange={(e) => onOptionLabelChange(o.questionOptionId, e.target.value)}
                        value={o.questionOptionLanguage !== undefined ? o.questionOptionLanguage?.find((ql) => ql.languageCode === props.lang)?.label || "" : ""}
                      />
                    </Col>
                    <Col className="col-2 text-right" style={{ margin: 0, /* marginLeft: 15, */ padding: 0 }}>
                      <ListItemSecondaryAction>
                        <IconButton className="icon-button-dark-s" edge="end" onClick={() => toggleModal(true)}>
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </Col>
                  </ListItem>
                  <ConfirmModal onAction={() => deleteOption(index)} onCancel={() => toggleModal(!modalOpen)} header={"AreYouSure"} open={modalOpen} text={"DoWantToDeleteOption"} />
                </Card>
              );
            }}
          />
        </List>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(EditQuestion);
